import type { ApiResponse } from "../factory";
import { BaseRepository } from "../factory";

export interface Catalog {
  id: number;
  file_id: number;
  title: string;
  description: string;
  created_at: string;
  updated_at: string;
  breadcrumbs: {
    label: string;
    url: string;
  }[];
  file: {
    data:
      | {
          id: number;
          title: string;
          type: string;
          ext: string;
          description: null;
          url: string;
          alt: null | string;
          caption: null | string;
          created_at: string;
          updated_at: string;
        }
      | [];
  };
  cover: {
    data:
      | {
          id: number;
          title: string;
          type: string;
          ext: string;
          description: null | string;
          url: string;
          alt: null | string;
          caption: null | string;
          created_at: string;
          updated_at: string;
        }
      | [];
  };
  seo: {
    data: {
      id: number;
      title: null | string;
      description: null | string;
      author: null | string;
      robots: null | string;
    };
  };
}

export class CatalogRepository extends BaseRepository<Catalog> {
  collection = "catalogs";
  language?: string;

  constructor(language?: string) {
    super();
    this.language = language;
  }

  getMany(
    queryParams?: Record<string, unknown>
  ): Promise<ApiResponse<Catalog[]>> {
    return super.getMany(queryParams);
  }
}
